import { hasAudioPermissions } from './hasAudioPermissions';
import { hasCameraPermission } from './hasCameraPermission';

export const hasMediaPermissions = async (checkMicrophone = true): Promise<boolean> => {
  const hasAudioPermission = await hasAudioPermissions(checkMicrophone);

  if (!hasAudioPermission) {
    return false;
  }

  return await hasCameraPermission();
};
